import React from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUserStore } from "@src/state/currentUserState";
import { isClinicAdmin } from "@src/utils/permission";

interface Props {
  children?: React.ReactNode;
  element?: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Gates a route or subtree so only active admins of the active clinic can see
 * it. When used as a route (`element` prop), non-admins are redirected to "/".
 * When used inline (`children`), non-admins render the `fallback` (default null).
 */
export default function RequiresClinicAdminContainer({
  children,
  element,
  fallback = null,
}: Props): React.ReactNode | null {
  const { currentUser } = useCurrentUserStore();
  const isRoute = !!element;

  if (!currentUser) {
    return fallback;
  }

  const allowed = isClinicAdmin(currentUser);
  const content = isRoute ? <>{element}</> : children;

  if (!allowed && isRoute) {
    return <Navigate to="/" replace />;
  }
  return allowed ? content : fallback;
}
